import React from 'react';
import { MultiSelectDropdown } from 'freemium-ui';
import { useTranslation } from 'react-i18next';
import { StyledMultiSelectDropdown } from './style';

const FilterMultiSelect = ({
  label,
  selected,
  options,
  handleChange,
  placeholder,
}: any) => {
  const { t } = useTranslation();
  const [selectedItems, setSelectedItems] = React.useState(
    selected ? selected.value : [],
  );
  const updateValues = (items: any) => {
    const payload = {
      type: 'MULTISELECT',
      value: items,
    };
    setSelectedItems(items);
    handleChange(payload);
  };
  React.useEffect(() => {
    if (!selected) {
      setSelectedItems([]);
    } else setSelectedItems(selected?.value);
  }, [selected]);
  return (
    <StyledMultiSelectDropdown>
      <MultiSelectDropdown
        name={label || ''}
        label={label || ''}
        selectedItem={selectedItems || []}
        items={options || []}
        onChange={(items: any) => {
          updateValues(items);
        }}
        placeholder={`${t(placeholder)}`}
        itemLabelIdentifier="label"
        itemValueIdentifier="display_id"
        customValues={!options.length}
      />
    </StyledMultiSelectDropdown>
  );
};

export default FilterMultiSelect;
